<template>
  <div>
    <div id="create-campaign">
      <div class="app-container mb-5" v-if="loaded">

        <v-container>
        <div class="page-title mb-3">
          Modification d'une Campagne d'adhésion
        </div>

          <v-text-field v-model="campaign.name"
                        background-color="white"
                        label="Nom de votre campagne"
                        outlined>
          </v-text-field>

          <v-stepper @change="setCurrentStep" non-linear :value="currentStep">
            <v-stepper-header>

              <v-stepper-step editable step="1">
                Contenu de l'e-mail
              </v-stepper-step>

                <v-stepper-step editable step="2">
                    Formulaire
                </v-stepper-step>

              <v-stepper-step editable step="3">
                Options
              </v-stepper-step>

              <v-stepper-step editable step="4">
                Finaliser
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>

              <v-stepper-content step="1">
                <email v-if="providers.length || selectedApidaeSelection"></email>
              </v-stepper-content>

                <v-stepper-content step="2">
                    <configuration-choice></configuration-choice>
                </v-stepper-content>

              <v-stepper-content step="3">
                <options :update-mode="true" :criterias="criterias" :is-revival="campaign.batches.length > 1">
                </options>
              </v-stepper-content>

              <v-stepper-content step="4">
                <finalize :cadh-name="campaign.name" :update-mode="true" :criterias="criterias"
                          :is-revival="campaign.batches.length > 1" :batch-id="campaign.last_batch.id">
                </finalize>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-container>
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex"
import Options from "./stepers/Options"
import Email from "./stepers/Email"
import Finalize from "./stepers/Finalize"
import * as EmailValidator from "email-validator"
import ConfigurationChoice from "./stepers/ConfigurationChoice.vue"

export default {
    name: "UpdateCadhCampaign",
    components: { Finalize, Email, Options, ConfigurationChoice },
    data() {
        return {
            campaign: { name: null },
            criterias: [],
            selectedCriterias: [],
            configId: null,
            loaded: false,
        }
    },
    methods: {
        ...mapMutations("createCadh", ["setCurrentStep", "setFirstPartMail", "setLastPartMail", "setSender", "resetState",
            "setSentAt", "setProviders", "setSubject", "setSignature", "setNoEmail", "setSingleEmail", "setEmailsValid",
            "setEmailsWrong", "setSelectedCriterias", "setCadhConfigId"]),
        getCadh() {
            this.$global.loading = true

      return this.$http.get('auth/campaigns/cadh/providers/' + this.cadhId).then(res => {
        this.campaign  = res.body.data.cadh

        let batch = this.campaign.last_batch

        if(batch.sent_at !== null) {
          let start = this.$moment(batch.sent_at)

          this.setSentAt(start)

          if (this.campaign.batches.length === 1 && window.location.href.indexOf("update") > -1) {
            // Cas update 1er envoi
            if (this.campaign.type === 'OBJ') {
              this.setProviders(batch.providers)
            } else {
              this.setProviders(batch.entities)
            }
          } else {
            // Cas création relances et update relances
            if (this.campaign.type === 'OBJ') {
              this.setProviders(batch.providers_not_answered)
            } else {
              this.setProviders(batch.entities_not_answered)
            }
          }

                    this.setFirstPartMail(batch.email_part1)
                    this.setLastPartMail(batch.email_part2)
                    this.setSender(this.campaign.sender)
                    this.setSubject(batch.email_subject)
                    this.setSignature(this.campaign.sender.signature)
                    this.setNoEmail(this.campaign.no_email)
                    this.setSingleEmail(this.campaign.single_email)
                    this.setCadhConfigId(this.campaign.cadh_configuration_id)
                    this.setEmailLists()

          if(this.campaign.with_filter) {
            this.setSelectedCommunes(this.campaign.communes.map(commune => commune.id))
            this.setSelectedTags(this.campaign.tags.map(tag => tag.id))
            this.setSelectedCategories(this.campaign.categories.map(category => category.id))
          }

          let criterias = this.campaign.apidae_criterias.map(criteria => criteria.external_id)

          this.setSelectedCriterias(criterias)

          if (this.campaign.apidae_selection) {
            let apidaeSelection = this.apidaeSelections.find(selection => selection.id === this.campaign.apidae_selection.external_id)

            this.setSelectedApidaeSelection(apidaeSelection)
          }
        }
    })
    },
    setEmailLists() {
      let emailsValid = []
      let emailsWrong = []

      if(this.providers.length === 0 && this.campaign.apidae_selection) {
        let apidaeSelection = this.apidaeSelections.find(selection => selection.id === this.campaign.apidae_selection.external_id)

        let payload = {
          projectId: apidaeSelection.projectId,
          selectionId: apidaeSelection.id,
          selectionName: apidaeSelection.nom,
          disabled: ['DOMAINE_SKIABLE_VTT', 'STRUCTURE']
        }
        this.$http.post('auth/account/apidae-selections/providers', payload).then(res => {
          this.setProviders(res.body.data.providers)
          this.loadingApidaeProviders = false
        })
      }

      this.providers.forEach(provider => {
        if(provider.contact === null) {
          provider.error = 'E-mail non renseigné'
          emailsWrong.push(provider)
        } else if(!EmailValidator.validate(provider.email)) {
          provider.error = 'Mauvais format d\'e-mail'
          emailsWrong.push(provider)
        } else {
          emailsValid.push(provider)
        }
      })

      this.setEmailsValid(emailsValid)
      this.setEmailsWrong(emailsWrong)
    },
    getInternalCriterias() {
      return this.$http.get('auth/account/apidae-criterias').then(res => {
        this.criterias = res.body.data.criterias
      })
    }
  },
  computed: {
    ...mapState('account', ['senders', 'account']),
    ...mapState('createCadh', ['currentStep', 'emailsValid', 'providers', 'selectedApidaeSelection'])
  },
  created() {
    let hash    = this.$route.params.hash
    this.cadhId = parseInt(atob(hash))

    this.resetState()

    this.$store.dispatch('account/fetchContacts')
    this.$store.dispatch('account/fetchCategories')
    this.$store.dispatch('account/fetchCommunes')
    this.$store.dispatch('account/loadSenders')

    const promise1 = this.getCadh()
    const promise2 = this.getInternalCriterias()

    Promise.all([promise1, promise2]).then(() => {
      setTimeout(() => {
        this.loaded = true

        this.$global.loading = false
      }, 100)
    })
  }
}
</script>